export default __webpack_public_path__ + "media/zurb/img/lab/patterntap/pattern-screenshot1-9d7aca9b6d10c2c359e4bdec7249f0b3.png";